// Suggested character names shown as clickable chips on the naming stage.
export const NAME_SUGGESTIONS: readonly string[] = [
  'Tarn',
  'Bloodsworn',
  'One-Eye',
  'Salt-Tooth',
  'Crimson',
  'Whisper',
];

// Reserved character names that no player can claim. Matched case-insensitively
// against the trimmed input. Covers staff/role words, the seven tutorial NPCs,
// and a handful of named NPCs from the design docs.
export const RESERVED_CHARACTER_NAMES: readonly string[] = [
  'admin',
  'mod',
  'moderator',
  'administrator',
  'system',
  'anthropic',
  'claude',
  'gm',
  'support',
  'staff',
  'official',
  'old pete',
  'mistress vela',
  'drillmaster bartolo',
  'sneaky jim',
  'quartermaster hale',
  'shipwright mara',
  'harbormaster finn',
  'governor',
  'governor ashcroft',
  'captain blackwood',
  'black jack hawthorne',
];

const RESERVED_LOOKUP = new Set(RESERVED_CHARACTER_NAMES.map((n) => n.toLowerCase()));

export function isReservedCharacterName(name: string): boolean {
  return RESERVED_LOOKUP.has(name.trim().toLowerCase());
}
